// extracted by mini-css-extract-plugin
export var infoSection = "_h-1";
export var infoSectionContainer = "_h-0";
export var infoSectionTitleRow = "_h-2";
export var multiLineInfo = "_h-4";
export var strong = "_h-3";